<template>
    <div
        v-if="(mode !== 'atBat' && pitcherPanelState === true) && currentAngle === 'pitcher'"
        class="pitcherController"
    >
        <div
            v-if="pitcherInputState === 0"
            class="pitcherDefaultWrapper"
        >
            <div
                class="close"
                @click="closePitcherPanel"
            >
                ×
            </div>
            <div class="pitcherPosition">
                <table>
                    <tr>
                        <td>投手位置</td>
                        <td @click="changePitcherInputState(1)">
                            {{ formatPitParams(slideParamsx2) }}cm
                        </td>
                    </tr>
                </table>
            </div>
            <div class="positionBar">
                <input
                    v-model="slideParamsx2"
                    type="range"
                    :min="currentBatterPointSet.slidePitPositionXMin"
                    :max="currentBatterPointSet.slidePitPositionXMax"
                    step="1"
                    value=""
                >
                <table class="rangeLabel">
                    <tr>
                        <td>L</td>
                        <td>Center</td>
                        <td>R</td>
                    </tr>
                </table>
            </div>
            <div class="pitcherPoint">
                <table>
                    <tr>
                        <td>投手目線</td>
                        <td @click="changePitcherInputState(2)">
                            {{ slideParamsy2 }}cm
                        </td>
                    </tr>
                </table>
            </div>
            <div class="pointBar">
                <input
                    v-model="slideParamsy2"
                    type="range"
                    :min="currentBatterPointSet.slidePitPointMin"
                    :max="currentBatterPointSet.slidePitPointMax"
                    step="1"
                    value=""
                >
                <table class="rangeLabel">
                    <tr>
                        <td>160</td>
                        <td>180</td>
                        <td>200</td>
                    </tr>
                </table>
            </div>
        </div>
        <div
            v-else-if="pitcherInputState === 1"
            class="pitcherInputWrapper"
        >
            <p>投手位置設定</p>
            <table class="pitcherInputInner">
                <tr>
                    <td>
                        <input
                            type="radio"
                            name="leftRight"
                            value=""
                            :checked="leftRightPitcherFlg"
                        >
                        <svg
                            width="55"
                            height="20"
                            @click="toggleLeftRightPitcherFlg(true)"
                        >
                            <text
                                x="0"
                                y="13"
                                font-size="11"
                                fill="#ffffff"
                            >左</text>
                            <circle
                                cx="30"
                                cy="10"
                                r="10"
                                fill="#222222"
                                stroke-width="0"
                                fill-opacity="0.75"
                            />
                            <circle
                                v-if="leftRightPitcherFlg"
                                cx="30"
                                cy="10"
                                r="5"
                                fill="#ffffff"
                                stroke-width="0"
                            />
                        </svg>
                    </td>
                    <td>
                        <input
                            type="radio"
                            name="leftRight"
                            value=""
                            :checked="!leftRightPitcherFlg"
                        >
                        <svg
                            width="20"
                            height="20"
                            @click="toggleLeftRightPitcherFlg(false)"
                        >
                            <text
                                x="0"
                                y="13"
                                font-size="11"
                                fill="#ffffff"
                            >右</text>
                            <circle
                                cx="30"
                                cy="10"
                                r="10"
                                fill="#222222"
                                stroke-width="0"
                                fill-opacity="0.75"
                            />
                            <circle
                                v-if="!leftRightPitcherFlg"
                                cx="30"
                                cy="10"
                                r="5"
                                fill="#ffffff"
                                stroke-width="0"
                            />
                        </svg>
                    </td>
                    <td>
                        <input
                            v-model.number="inputParamsx2"
                            type="number"
                            value="0"
                            @input="validPitcherParamsx($event, inputParamsx2)"
                            @blur="blurAfter"
                        ><span
                            class="unit"
                        > cm</span>
                    </td>
                </tr>
            </table>
            <table class="pitcherSubmitButton">
                <tr>
                    <td @click="changePitcherInputState(0)">
                        <span>キャンセル</span>
                    </td>
                    <td>
                        <span
                            v-if="pitcherPositionIsValid"
                            class="disabledBtn"
                        >設定する</span>
                        <span
                            v-else
                            @click="submitPitcherPosition"
                        >設定する</span>
                    </td>
                    <td><span @click="resetPitcherPosition">リセット</span></td>
                </tr>
            </table>
        </div>
        <div
            v-else-if="pitcherInputState === 2"
            class="pitcherInputWrapper point"
        >
            <p>投手目線設定</p>
            <table class="pitcherInputInner">
                <tr>
                    <td>
                        <input
                            v-model.number="inputParamsy2"
                            type="number"
                            value=""
                            @input="validPitcherParamsy($event, inputParamsy2)"
                            @blur="blurAfter"
                        ><span
                            class="unit"
                        > cm</span>
                    </td>
                </tr>
            </table>
            <table class="pitcherSubmitButton">
                <tr>
                    <td @click="changePitcherInputState(0)">
                        <span>キャンセル</span>
                    </td>
                    <td>
                        <span
                            v-if="pitcherPointIsValid"
                            class="disabledBtn"
                        >設定する</span>
                        <span
                            v-else
                            @click="submitPitcherPoint"
                        >設定する</span>
                    </td>
                    <td><span @click="resetPitcherPoint">リセット</span></td>
                </tr>
            </table>
        </div>
    </div>
</template>

<script>
import Common3dPitcherController from '@/components_common/3d/PitcherController.vue'

export default {
    mixins: [Common3dPitcherController],
}
</script>

<style scoped>
/* 投手位置・投手目線 */
.pitcherController {
    position: absolute;
    color: #fff;
    width: 250px;
    background: rgba(51, 51, 51, 0.95);
    padding-bottom: 15px;
    margin-top: 10px;
    top: 301px;
    right: 84px;
}

.pitcherPosition {
    padding: 10px 15px 0;
    font-size: 13px;
    line-height: 13px;
}

.pitcherPosition tr td {
    width: 60px;
    height: 20px;
    font-size: 13px;
    text-align: left;
    vertical-align: middle;
}

.pitcherPosition tr td:nth-child(2) {
    width: 110px;
    height: 20px;
    background-color: rgba(34, 34, 34, 0.75);
    font-size: 11px;
    text-align: center;
}

.positionBar {
    padding: 15px 0 10px;
}

.pitcherPoint {
    padding: 15px 15px 0;
    font-size: 13px;
    line-height: 13px;
}

.pitcherPoint tr td {
    width: 60px;
    height: 20px;
    font-size: 13px;
    text-align: left;
    vertical-align: middle;
}

.pitcherPoint tr td:nth-child(2) {
    width: 110px;
    height: 20px;
    background-color: rgba(34, 34, 34, 0.75);
    font-size: 11px;
    text-align: center;
}

.pointBar {
    padding: 15px 0 0;
}

/* 投手位置設定パネル */
.pitcherInputWrapper {
    width: 250px;
    padding: 10px 15px 0;
    font-size: 13px;
    height: 204px;
}

.pitcherInputWrapper p {
    padding-top: 2px;
    font-size: 13px;
    line-height: 13px;
}

.pitcherInputWrapper table.pitcherInputInner {
    width: 220px;
    margin: 62px auto;
}

.pitcherInputWrapper table.pitcherInputInner tr {
    width: 100%;
    height: 24px;
    box-sizing: border-box;
}

.pitcherInputWrapper table.pitcherInputInner tr td {
    width: 110px;
    height: 24px;
    box-sizing: border-box;
    padding-bottom: 0;
}

.pitcherInputWrapper table.pitcherInputInner tr td:nth-child(1),
.pitcherInputWrapper table.pitcherInputInner tr td:nth-child(2) {
    width: 55px;
}

.pitcherInputWrapper table.pitcherInputInner tr td input[type="number"] {
    -webkit-appearance: none;
}

.pitcherInputWrapper table.pitcherInputInner tr td input[type="radio"] {
    display: none;
}

.pitcherInputWrapper table.pitcherInputInner tr td input[type="number"] {
    width: 80px;
    height: 24px;
    outline: none;
    border: none;
    background: rgba(34, 34, 34, 0.75);
    color: #ffffff;
    text-align: center;
    line-height: 13px;
    float: left;
    font-size: 11px;
}

.pitcherInputWrapper table.pitcherInputInner tr td .unit {
    padding-top: 4px;
    padding-left: 10px;
    float: left;
}

.pitcherInputWrapper table.pitcherInputInner tr:nth-child(2) td {
    padding-bottom: 0;
}

.pitcherInputWrapper table.pitcherInputInner tr td svg {
    width: 55px;
    height: 24px;
    box-sizing: border-box;
}

.pitcherInputWrapper table.pitcherSubmitButton {
    width: 220px;
    margin: 0 auto 10px;
}

.pitcherInputWrapper table.pitcherSubmitButton tr {

}

.pitcherInputWrapper table.pitcherSubmitButton tr td {
    width: 66px;
    text-align: center;
    padding: 0 5px;
}

.pitcherInputWrapper table.pitcherSubmitButton tr td:nth-child(1) {
    padding-left: 0;
}

.pitcherInputWrapper table.pitcherSubmitButton tr td:nth-child(3) {
    padding-right: 0;
}

.pitcherInputWrapper table.pitcherSubmitButton tr td span {
    width: 66px;
    height: 24px;
    display: inline-block;
    font-size: 11px;
    padding-top: 5px;
    border: 1px solid #ffffff;
    box-sizing: border-box;
}

/* 投手目線設定パネル */
.pitcherInputWrapper.point table.pitcherInputInner {
    margin: 62px auto;
}

.pitcherInputWrapper.point table.pitcherInputInner tr td {
    box-sizing: border-box;
    padding-bottom: 0;
}

.pitcherInputWrapper.point table.pitcherInputInner tr td input[type="number"] {
    margin-left: 54px;
}

/* slider */
[type="range"] {
    display: block;
    position: relative;
    width: 220px;
    margin: 0 auto;
    height: 1px;
    background-color: rgba(255, 255, 255, 1);
    z-index: 1;
}

[type="range"]::-webkit-slider-thumb {
    -webkit-appearance: none;
    position: relative;
    z-index: 15;
    width: 12px;
    height: 12px;
    background-color: rgba(255, 255, 255, 1);
    -webkit-border-radius: 100%;
    -moz-border-radius: 100%;
    border-radius: 100%;
    cursor: pointer;
    user-select: none;
    -moz-user-select: none;
    -webkit-user-select: none;
    -ms-user-select: none;
}

[type="range"]:focus,
[type="range"]:focus::-webkit-slider-thumb,
[type="range"]:active,
[type="range"]:active::-webkit-slider-thumb {
    outline: none;
}

[type="range"]:active::-webkit-slider-thumb {
    background-color: rgba(255, 20, 147, 1.0);
}

/* slider label */
.rangeLabel {
    width: 220px;
    margin: 10px auto 0;
}

.rangeLabel tr td:nth-child(1) {
    text-align: left;
}

.rangeLabel tr td:nth-child(2) {
    text-align: center;
}

.rangeLabel tr td:nth-child(3) {
    text-align: right;
}

.close {
    width: 25px;
    height: 25px;
    position: absolute;
    color: #fff;
    line-height: 25px;
    font-size: 20px;
    top: 8px;
    right: 10px;
    cursor: pointer;
}

.disabledBtn {
    opacity: 0.65;
}

.disable {
    opacity: 0.5;
}
</style>
